<template>
  <div class="bookNavigation"
      @keyup.tab="addOutline()"
    >
    <span role="button"
      v-visible="!atFirstPage"
      :tabindex="!atFirstPage ? 0 : -1"
      aria-label="previous page"
      @click="turnLeftPage()"
      @keyup.enter="turnLeftPage()"
      @keyup.tab="addOutline()"
      class="icon"
      :class="{ outlined: isOutlined }"
      :style="iconStyles"
    >
      <arrow-left-svg/>
    </span>
    <span role="button"
      v-if="!audioPlaying"
      v-visible="hasAudioSource"
      :tabindex="hasAudioSource && !audioPlaying ? 0 : -1"
      aria-label="play audio"
      @click="toggleAudio()"
      @keyup.enter="toggleAudio()"
      @keyup.tab="addOutline()"
      class="icon"
      :class="{ outlined: isOutlined }"
      :style="iconStyles"
    >
      <volume-up-svg/>
    </span>
    <span role="button"
      v-if="audioPlaying"
      v-visible="hasAudioSource"
      :tabindex="hasAudioSource && audioPlaying ? 0 : -1"
      aria-label="stop audio"
      @click="toggleAudio()"
      @keyup.enter="toggleAudio()"
      @keyup.tab="addOutline()"
      class="icon"
      :class="{ outlined: isOutlined }"
      :style="iconStyles"
    >
      <volume-mute-svg/>
    </span>
    <span role="button"
      v-if="!atEndPage"
      tabindex="0"
      aria-label="next page"
      @click="turnRightPage()"
      @keyup.enter="turnRightPage()"
      @keyup.tab="addOutline()"
      class="icon visible"
      :class="{ outlined: isOutlined }"
      :style="iconStyles"
    >
      <arrow-right-svg/>
    </span>
    <span
      v-else @click="goToHomePage()"
      role="button"
      tabindex="0"
      aria-label="go home"
      @keyup.enter="goToHomePage()"
      @keyup.tab="addOutline()"
      class="icon visible"
      :class="{ outlined: isOutlined }"
      :style="iconStyles"
    >
      <home-svg/>
    </span>
  </div>
</template>

<script>
  import homeSvg from '../icons/home.vue'
  import arrowLeftSvg from '../icons/arrowLeft.vue'
  import arrowRightSvg from '../icons/arrowRight.vue'
  import volumeUpSvg from '../icons/volumeUp.vue'
  import volumeMuteSvg from '../icons/volumeMute.vue'
  export default {
    name: 'book-navigation',
    components: {
      homeSvg,
      arrowLeftSvg,
      arrowRightSvg,
      volumeUpSvg,
      volumeMuteSvg
    },
    props: {
      atFirstPage: {
        type: Boolean,
        default: true
      },
      atEndPage: {
        type: Boolean,
        default: false
      },
      hasAudioSource: {
        type: Boolean,
        default: false
      },
      audioPlaying: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: "#888"
      },
    },
    data () {
      return {
        isOutlined: false, // Whether we need to show outlines around the nav controls
      }
    },
    methods: {
      // Turn the page towards the left
      turnLeftPage () {
        this.$emit('turnLeftPage')
      },
      turnRightPage () {
        this.$emit('turnRightPage')
      },
      goToHomePage () {
        this.$emit('goToHomePage')
      },
      addOutline () {
        // Show outlines
        this.isOutlined = true
      },
      toggleAudio () {
        this.$emit('toggleAudio')
      },
    },
    computed: {
      iconStyles () {
        return {
          color: this.color,
        }
      },
    },
  }
</script>

<style scoped>
  .bookNavigation{
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 3.75vw; /* approx 1600 width / 60 height */
    max-height: 60px;
    background-color: #eee;
  }
  .bookNavigation .icon{
    /* color: #888; */
    display: flex;
    height: 2.3vw;
    max-height: 30px;
    width: 2.3vw;
    max-width: 30px;
    padding: .25em;
    opacity: 1;
    transition: opacity .25s ease-in-out;
  }
  .bookNavigation .icon.visible{
    cursor: pointer;
    width: 100%;
  }
  .bookNavigation .icon.visible:hover{
    opacity: .7 !important;
  }
  .bookNavigation .icon:focus{
    outline: none;
  }
  .bookNavigation .icon.visible.outlined:focus{
    outline: currentColor dashed 1px;
  }
</style>



// WEBPACK FOOTER //
// bookNavigation.vue?2a56f6dd